export const compareByName = (a, b, name = 'name') => {
  const prevValue = a[name];
  const currentValue = b[name];

  if (Array.isArray(prevValue)) {
    if (prevValue.join('') < currentValue.join('')) return -1;
    if (prevValue.join('') > currentValue.join('')) return 1;
  } else {
    if (prevValue < currentValue) return -1;
    if (prevValue > currentValue) return 1;
  }

  return 0;
};
export const compareIgnoreCase = (str1, str2) => {
  const regex = new RegExp(str2, 'i');
  return regex.test(str1);
}
export const _storageTimeoutExpired = () => {
  const expiredTime = parseInt(localStorage.getItem('_expiredTime'), 10);
  return expiredTime > 0 && expiredTime < Date.now();
};

export const _setStorageTimeout = (inactiveTimeAllowed = 0) => {
  localStorage.setItem('_expiredTime', inactiveTimeAllowed === 0 ? 0 : Date.now() + inactiveTimeAllowed);
};

export const dynamicSort = (property) => {
  const sortOrder = /^-/.test(property) ? -1 : 1;
  const key = property.replace(/^-/, '');
  return (a, b) => {
    const result = a[key] < b[key] ? -1 : a[key] > b[key] ? 1 : 0;
    return result * sortOrder;
  };
};

export const getHtmlElUID = (prefix = 'lsn_el_') => prefix + '_' + Math.random().toString(36).substr(2, 12);

export const uStripHtmlTags = (text = '') => text.replace(/\&nbsp;/g, ' ').replace(/(<([^>]+)>)/gi, '');